export default {
  default: {
    number: "Please enter a number.",
    max: "You can only use a maximum of ${max} characters here",
    required: "This is a required field.",
    requiredShort: "Required field.",
  },
  layout: {
    required: "Please select one or more layout options.",
  },
  name: {
    min: "Your name must be at least ${min} chars",
    required: "Please enter your name.",
  },
  surname: {
    required: "Please enter your surname.",
  },
};
